import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { initObservability } from './lib/observability'
import './styles/globals.css'

// Initialize observability (Sentry)
initObservability()

const CHUNK_RELOAD_KEY = 'secbra.vite-preload-reload'

function installChunkReloadFallback() {
  const reloadOnce = () => {
    if (sessionStorage.getItem(CHUNK_RELOAD_KEY) === '1') {
      sessionStorage.removeItem(CHUNK_RELOAD_KEY)
      return
    }

    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1')
    window.location.reload()
  }

  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()
    reloadOnce()
  })

  window.addEventListener('pageshow', () => {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY)
  })
}

installChunkReloadFallback()

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
)
